<template>
    <div :class="itemClass">
        <router-link :to="route">
            <div v-if="!isNested || !showText">
                <common-icon v-if="icon" :name="icon" size="huge"></common-icon>

                <transition name="fade" mode="in-out">
                    <span v-show="!showText" :class="contentClass">
                        {{ label }}
                        <span v-show="isHighlightNeeded">
                            {{ highlight }}
                        </span>
                    </span>
                </transition>
            </div>
        </router-link>
    </div>
</template>

<script>
    import { isRouteNameEqual, matchFullRoute } from '~/helpers'

    export default {
        props: {
            route: { type: Object, default: undefined },
            label: { type: String, required: true },
            icon: { type: String, default: undefined },
            isNested: { type: Boolean, default: false },
            highlight: { type: String, default: '' },
            isSubmenu: { type: Boolean, default: false },
            showText: { type: Boolean, default: false },
        },

        data() {
            return {
                isOverflowing: false,
            }
        },

        computed: {
            itemClass() {
                return {
                    'app-main-menu__item': true,
                    'app-main-menu__item--is-current': this.route
                        ? this.route.matchFullRoute
                            ? matchFullRoute(this.route, this.$route, 2)
                            : isRouteNameEqual(this.route.name, this.$route.name, 2)
                        : false,
                    'app-main-menu__item--is-nested': this.isNested,
                    'app-main-menu__item--is-submenu': this.isSubmenu && !this.showText,
                }
            },

            defaultClassName() {
                return 'menu-item-label'
            },

            isHighlightNeeded() {
                return this.highlight && this.isOverflowing
            },

            contentClass() {
                return this.defaultClassName + (this.isHighlightNeeded ? ' full-label-text' : '')
            },
        },

        mounted() {
            const currentPosition = this.$el.style.position
            this.$el.style.position = 'relative'
            const spanElement = this.$el.getElementsByClassName(this.defaultClassName)[0]
            this.isOverflowing =
                spanElement?.clientWidth < spanElement?.scrollWidth || spanElement?.clientHeight < spanElement?.scrollHeight
            this.$el.style.position = currentPosition
        },
    }
</script>
